
import { configureStore } from "@reduxjs/toolkit";
import communityReducer from "../Services/Community/CommunitySlice/communitySlice";
import communitybyNameReducer from "../Services/Community/CommunitySlice/communityByCommunityNameSlice";
import communityByIdReducer from "../Services/Community/CommunitySlice/communityByIdSlice";
import userLoginReducer from "../Services/Login/LoginSlice/loginSlice";
import forgotPasswordReducer from "../Services/Login/LoginSlice/ForgotPasswordslice";
import otpVerificationReducer from "../Services/Login/LoginSlice/otpverificationSlice";
import userResetPasswordReducer from "../Services/Login/LoginSlice/ResetPasswordSlice";
import userSignUpReducer from "../Services/Signup/SignupSlice/SignupSlice";
import fetchUserTypeReducer from "../Services/Signup/SignupSlice/userTypeSlice";
import idReducer from "../Services/Community/CommunitySlice/idSlice";
import fetchProfileDataSlice from "../Services/Profile/ProfileSlice";
import uiReducer from "../Services/DashboardHeader/uiSlice";
import updateProfileApiSlice from "../Services/updateProfile/updateProfileSlice";
const store = configureStore({
  reducer: {
    community: communityReducer,
    communityByName: communitybyNameReducer,
    communityById: communityByIdReducer,
    userLogin: userLoginReducer,
    forgotPassword: forgotPasswordReducer,
    otpVerification: otpVerificationReducer,
    userResetPassword: userResetPasswordReducer,
    userSignUp: userSignUpReducer,
    fetchUserType: fetchUserTypeReducer,
    id: idReducer,
    fetchProfileData: fetchProfileDataSlice,
    ui: uiReducer,
    profileUpdate: updateProfileApiSlice,
  },
});

export default store;
